<template>
    <div class="profile">
        <vs-tabs alignment="left" :position="position" :class="{'extended': horizontal}">
            <vs-tab icon="account_circle" label="Datos básicos">
                <div>
                    <div class="picture">
                        <vs-avatar :src="profileImg" size="120px"/>
                        <div class="buttons">
                            <vs-button class="" color="primary" type="border" @click="popupActivo4=true">Subir foto</vs-button>
                            <vs-button type="border" color="danger" @click="removeProfileImage">Eliminar</vs-button>
                            <p class="formats">Formatos permitidos JPG, GIF or PNG.</p>
                        </div>
                    </div>
                    <div class="user-form form" v-if="userInfoData.customer === null">
                        <div :class="['form-input', {'has-error': $v.user.email.$error }]">
                            <vs-input label="Correo Electrónico" disabled v-model="$v.user.email.$model"/>
                            <span class="error-text" v-if="$v.user.email.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div class="group">
                            <div :class="['form-input', {'has-error': $v.user.name.$error }]">
                                <vs-input label="Nombre"  v-model="$v.user.name.$model"/>
                                <span class="error-text" v-if="$v.user.name.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input', {'has-error': $v.user.lastName.$error }]">
                                <vs-input label="Apellidos"  v-model="$v.user.lastName.$model"/>
                            </div>
                        </div>
                        <div class="form-input footer">
                            <vs-button :disabled="$v.user.$invalid" id="btnConfirm" color="success" type="border"
                            @click="updateUser" class="vs-con-loading__container">Actualizar</vs-button>
                        </div>
                    </div>
                    <div class="customer-form form" v-if="userInfoData.customer !== null">
                        <div class="group">
                            <div class="form-input">
                                <label class="vs-input--label">Tipo Casillero</label>
                                <select-input :options="lockers" v-model="$v.customer.customerType.$model" :disabled="true"></select-input>
                            </div>
                            <div :class="['form-input', {'has-error': $v.customer.email.$error }]">
                                <vs-input label="Correo Electrónico" disabled v-model="$v.customer.email.$model"/>
                                <span class="error-text" v-if="$v.customer.email.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                        </div>
                        <div class="group">
                            <div :class="['form-input', {'has-error': $v.customer.dni.$error }]">
                                <vs-input label="Cédula o pasaporte"  v-model="$v.customer.dni.$model"/>
                                <span class="error-text" v-if="$v.customer.dni.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input', {'has-error': $v.customer.name.$error }]">
                                <vs-input label="Nombre"  v-model="$v.customer.name.$model"/>
                                <span class="error-text" v-if="$v.customer.name.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                        </div>
                        <div class="group">
                            <div :class="['form-input', {'has-error': $v.customer.lastName.$error }]">
                                <vs-input label="Apellidos"  v-model="$v.customer.lastName.$model"/>
                            </div>
                            <div :class="['form-input', {'has-error': $v.customer.birthday.$error }]">
                                <label class="vs-input--label">Fecha Nacimiento</label>
                                <v-date-picker v-model="$v.customer.birthday.$model" locale="es"></v-date-picker>
                                <span class="error-text" v-if="$v.customer.birthday.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                        </div>
                        <div class="group">
                            <div :class="['form-input',{'has-error': $v.customer.mobile.$error }]" >
                                <vs-input label="Célular"  v-model.trim="$v.customer.mobile.$model" @keypress="isNumber($event)"/>
                                <span class="error-text" v-if="$v.customer.mobile.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div class="form-input">
                                <vs-input label="Teléfono" v-model.trim="customer.phone" @keypress="isNumber($event)"/>
                            </div>
                        </div>
                        <div class="group">
                            <div class="form-input">
                                <vs-input label="Profesión" v-model.trim="customer.profession"/>
                            </div>
                            <div class="form-input">
                                <vs-input label="Pasatiempos" v-model.trim="customer.hobbie"/>
                            </div>
                        </div>
                        <div class="group">
                            <div :class="['form-input',{'has-error': $v.customer.delivery.$error }]" >
                                <label class="vs-input--label">¿Dónde quieres recibir tu paquete?</label>
                                <select-input :options="deliveries" v-model="$v.customer.delivery.$model"></select-input>
                            </div>
                            <div class="form-input">
                                    <label class="vs-input--label">Como te gustaría ser notificado?</label>
                                <div class="switch-group">
                                    <label for="">WhatsApp</label>
                                    <vs-switch color="success" v-model="customer.whatsapp"/>
                                </div>
                                <div class="switch-group">
                                    <label for="">Llamada</label>
                                    <vs-switch color="success" v-model="customer.byCall"/>
                                </div>
                                <div class="switch-group">
                                    <label for="">Correo</label>
                                    <vs-switch color="success" v-model="customer.byMail"/>
                                </div>
                            </div>
                        </div>                   
                        <div class="form-input footer">
                            <vs-button :disabled="$v.customer.$invalid" id="btnConfirm" color="success" type="border"
                            @click="updateCustomer" class="vs-con-loading__container">Actualizar</vs-button>
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab icon="location_on" label="Direción" v-if="userInfoData.customer != null">
                <div class="form">
                    <div :class="['form-input',{'has-error': $v.customerAddress.province.$error }]" >
                        <label class="vs-input--label">Provincia</label>
                        <select-input :options="provinces" v-model="$v.customerAddress.province.$model" @input="filterCanton"></select-input>
                    </div>
                    <div :class="['form-input',{'has-error': $v.customerAddress.canton.$error }]" >
                        <label class="vs-input--label">Cantón</label>
                        <select-input :options="tempCanton" v-model="$v.customerAddress.canton.$model" @input="filterDistricts"></select-input>
                    </div>
                    <div :class="['form-input',{'has-error': $v.customerAddress.district.$error }]" >
                        <label class="vs-input--label">Distrito</label>
                        <select-input :options="tempDistrict" v-model="$v.customerAddress.district.$model"></select-input>
                    </div>
                    <div :class="['form-input',{'has-error': $v.customerAddress.address.$error }]" >
                        <vs-input label="Otras señas"  v-model="$v.customerAddress.address.$model"/>
                    </div>
                    <div class="form-input footer">
                        <vs-button :disabled="$v.customerAddress.$invalid" id="btnConfirm" color="success" type="border"
                        @click="updateCustomerAddress" class="vs-con-loading__container">Actualizar</vs-button>
                    </div>
                </div>                
            </vs-tab>
            <vs-tab icon="security" label="Cambiar Contraseña">
                <div class="form">
                    <div :class="['form-input', {'has-error': $v.objChangePass.password.$error }]">
                        <vs-input type="password" label="Actual Contraseña" v-model="$v.objChangePass.password.$model"/>
                        <span class="error-text" v-if="$v.objChangePass.password.$error"><feather type="info" />Este campo es requerido</span>
                    </div>                    
                    <div :class="['form-input', {'has-error': $v.objChangePass.newpassword.$error }]">
                        <vs-input type="password" label="Contraseña" v-model="$v.objChangePass.newpassword.$model"/>
                        <span class="error-text" v-if="$v.objChangePass.newpassword.$error"><feather type="info" />Las contaseñas no coinciden.</span>
                    </div>
                    <div :class="['form-input', {'has-error': $v.objChangePass.confirmPass.$error }]">
                        <vs-input type="password" label="Confirmar Contraseña" v-model="$v.objChangePass.confirmPass.$model"/>
                        <span class="error-text" v-if="$v.objChangePass.confirmPass.$error"><feather type="info" />Las contaseñas no coinciden.</span>
                    </div>
                    <div class="form-input footer">
                        <vs-button :disabled="$v.objChangePass.$invalid" id="btnConfirm" color="success" type="border"
                        @click="changePassword" class="vs-con-loading__container">Actualizar</vs-button>
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>
        <vs-popup class="media-wrapper" fullscreen title="Imagenes de perfil" :active.sync="popupActivo4">
                <vs-tabs>
                    <vs-tab label="Galería">
                        <div class="media-content">
                            <div :class="['gallery', { w100: resourceSelected === 0}]">
                                <div class="wrrapper">
                                    <template v-for="(image, index) in resources">
                                        <div :key="`s-${index}`" :class="['sigle-image', {active: resourceSelected.id === image.id}]" v-if="!isPdf(image.url)">
                                            <img :src="image.url" alt="" @click="findResource(image.id, index)">
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="gallery-sidebar" v-if="resourceSelected !== 0">
                                <div class="detail">
                                    <div class="title">Foto</div>
                                    <div class="feature">
                                        <img :src="resourceSelected.url"/>
                                    </div>
                                    <div class="actions">
                                        <vs-button color="success" type="border" icon="check" @click="closeModalResource">Seleccionar</vs-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    
                    <vs-tab label="Subir Imagen">
                        <div class="dropzone-wrapper">
                            <vue-dropzone :options="dropzoneOpts" id="upload-images"
                                v-on:vdropzone-success="successUploaded" v-on:vdropzone-sending="sendingBeforeDropzone"> </vue-dropzone>
                        </div>
                    </vs-tab>
                </vs-tabs>
        </vs-popup>
    </div>
</template>
<script>
import Http  from '@/helpers/Http.js'
import {helper} from '@/helpers/utils'
import vueDropzone from 'vue2-dropzone'
import { mapState, mapActions } from 'vuex'
import Customer from "@/models/ClientModel"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import UserDataService from "@/services/UserDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import ClientDataService from "@/services/ClientDataService"
import ResourceDataService from "@/services/ResourceDataService"
import { required, sameAs, minLength, email} from 'vuelidate/lib/validators'
export default {
  name: "Profile",
  mixins: [helper],
  components: {
    vueDropzone,
    SelectInput
  },
  data () {
    return {
      resourceSelected: 0,
      deliveries: [],
      position: 'top',
      horizontal: true,
      defaultImg: 'https://randomuser.me/api/portraits/men/85.jpg',
      profileImg: "",
      popupActivo4:false,
      changePwdStatus: false,
      lockers: [],
      customer: new Customer(),
      provinces: [],
      cantons: [],
      districts: [],
      tempCanton: [],
      tempDistrict: [],
      resources:[],
      customerAddress: {
        customer: "",
        province: {},
        canton: {},
        district: {},
        address: "",
        userupd: ''
      },
      user: {
          id: '',
          name: '',
          lastName: "", 
          email: ''
      },
      objChangePass: {
          email: '',
          password: '',
          newpassword: '',
          confirmPass: '',
      },
    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
    dropzoneOpts() {
       return {
            url: Http.defaultApi + '/files/upload',
            thumbnailWidth: 150,
            maxFilesize: 5,
            method: "POST",
            withCredentials: false,
            acceptedFiles: ".jpg,.jpeg,.png,.gif,.mp4",
            headers: { 
            'Access-Control-Allow-Origin': '*',
            'authorization':  this.userInfoData.boxkey,
            'x-access-token': this.userInfoData.boxkey
            }
       };
    }
  },
  mounted (){
    // this.objChangePass.email = this.currentUser.user.email
    this.retrieveResources()
    this.retrieveLocationsDelivery()
    this.retrieveCustomerTypes()
    if(this.userInfoData.customer != null){
        this.loadCustomerFromStore()
        this.customer.profileUrl  = this.userInfoData.profileUrl
    }else{
        this.user.email = this.userInfoData.email
        this.user.name  = this.userInfoData.name
        this.user.lastName = this.userInfoData.lastName
        this.user.profileUrl  = this.userInfoData.profileUrl
    }
    this.objChangePass.email = this.userInfoData.email
    this.profileImg  = this.userInfoData.profileUrl
    this.retrieveLocations()
  },
  validations: {
    user:{ 
        name: { required },
        lastName: { required },
        email: { required },
    },
    customer: {
        customerType: {required},
        dni: { required },
        name: { required },
        lastName   : { required },
        email : { required, email },
        mobile : { required },
        birthday : { required },
        delivery : { required },
    },
    objChangePass: 
        {   
            email: { required },
            password: { required },
            newpassword: 
            { 
                required,
                minLength: minLength(6)
            },
            confirmPass: { sameAsPassword: sameAs('newpassword') }
        },
    customerAddress: {
        customer: {required},
        province: {required},
        canton: {required},
        district: {required},
        address: {required},
    }
  },
  methods: {
    ...mapActions([
      'addUserInfo',
      'updatedUserInfo'
    ]),
    removeProfileImage(){
        this.profileImg = ''
        this.user.profileUrl = ''
        this.customer.profileUrl = ''
    },
    closeModalResource () {
        
        this.user.profileUrl  = this.resourceSelected.url+"?v="+this.getRandomNumber();
        this.customer.profileUrl = this.resourceSelected.url+"?v="+this.getRandomNumber();
        this.profileImg  = this.resourceSelected.url +'?v='+this.getRandomNumber()
        this.popupActivo4 = false
    },
    findResource(_id){
      let found = this.resources.filter((item) => {
        return  _id === item.id
      })
      if( found.length > 0) {
        this.resourceSelected = found[0]
      }
    },
    
    successUploaded (file, response) {
        console.log('File', file);
        if(response.url !== ''){
            
            this.user.profileUrl  = response.url +'?v='+this.getRandomNumber()
            this.customer.profileUrl = response.url +'?v='+this.getRandomNumber()
            this.profileImg  = response.url +'?v='+this.getRandomNumber()
            this.popupActivo4 = false
        }
    },
    sendingBeforeDropzone (file, xhr, formData) {
        console.log('DEBUG: formData BEFORE ' + formData)
        formData.append('type', 'Profile');
        formData.append('fileName', this.customer.id);
        formData.append('customer', this.userInfoData.customer != null ? this.customer.id : this.user.email);
    },
    
    retrieveResources() {
        ResourceDataService.getFiles('Profile')
        .then(response => {
            console.log('RE',response.data)
            this.resources = response.data
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los archivos!',color:'danger',icon:'error_outline'})
        });
    },   
    
    changePassword(){
        this.loadingProgress ('#btnConfirm')
        this.changePwdStatus = true
        UserDataService.chagePassword(this.objChangePass)
        .then(response => {
            this.changePwdStatus = false
            console.log(response)
            this.$vs.loading.close('#btnConfirm .con-vs-loading')
            this.$vs.notify({title:'Información!',text:'La contraseña fue actualizada exitosamente!',color:'success',icon:'check'})
            this.objChangePass.password = ''
            this.objChangePass.newpassword = ''
            this.objChangePass.confirmPass = ''
            this.$v.objChangePass.$reset()
        })
        .catch(e => {
            console.log(e)
            this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            this.changePwdStatus = false
            this.$vs.notify({title:'Información!',text:e.body,color:'danger',icon:'error_outline'})                
        });
    },
    retrieveLocationsDelivery() {
        ClientDataService.getLocationsDelivery()
        .then(response => {
            this.deliveries = response.data
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo los lugares de entrega!',color:'danger',icon:'error_outline'})
        });
    },
    retrieveCustomerTypes() {
        ClientDataService.getCustomerTypes()
        .then(response => {
            this.lockers = response.data;
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo las tipos de clientes!',color:'danger',icon:'error_outline'})
        });
    }, 
    updateUser(){
        this.$v.user.$touch()
        if (this.$v.user.$invalid) return

        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true
        UserDataService.updateUserProfile(that.user)
        .then(response => {
            that.confirmStatus = false
            console.log('Actualizado',response)
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'El usuario fue actualizado exitosamente!',color: 'success',icon:'check'})
            this.refreshCustomerStore()
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error actualizando al usuario',color:'danger',icon:'error_outline'})                
        });

    },
    updateCustomer(){
        
        this.$v.customer.$touch()
        if (this.$v.customer.$invalid) return

        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true
        that.customer.byMail   = that.customer.byMail == true ? 1 : 0
        that.customer.byCall   = that.customer.byCall == true ? 1 : 0
        that.customer.whatsapp = that.customer.whatsapp == true ? 1 : 0
        ClientDataService.update(that.customer)
        .then(response => {
            that.confirmStatus = false
            console.log('Actualizado',response)
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'El cliente fue actualizado exitosamente!',color: 'success',icon:'check'})
            //this.$refs.wizard.reset();
            that.customer.identification = that.customer.dni
            that.customer.firstName = that.customer.name
            that.customer.birthdate = that.customer.birthday
            that.customer.dlvCode = that.customer.delivery.code
            that.customer.dlvName = that.customer.delivery.name
            that.customer.pvcode  = that.customer.province.code
            that.customer.pvname  = that.customer.province.name
            that.customer.ctcode  = that.customer.canton.code
            that.customer.ctname  = that.customer.canton.name
            that.customer.dtcode  = that.customer.district.code
            that.customer.dtname  = that.customer.district.name
            that.customer.typecode = that.customer.customerType.code
            that.customer.typename = that.customer.customerType.name
            that.customer.bymail   = that.customer.byMail == true ? 1 : 0
            that.customer.bycall   = that.customer.byCall == true ? 1 : 0
            that.refreshCustomerStore()
        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error actualizando el cliente',color:'danger',icon:'error_outline'})                
        });

    },   
    retrieveLocations() {
        ClientDataService.getLocationAddress()
        .then(response => {
            this.provinces = response.data.provinces;
            this.cantons   = response.data.cantons;
            this.districts = response.data.districts;
            // Filtro los selects de acuerdo a lo que tiene customer
            if(this.userInfoData.customer != null){
                this.filterCanton(this.customer.province)
                this.filterDistricts(this.customer.canton)
                this.customerAddress.province = this.customer.province
                this.customerAddress.canton   = this.customer.canton
                this.customerAddress.district = this.customer.district
                this.customerAddress.address = this.userInfoData.customer.address
            }
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo las provincias!',color:'danger',icon:'error_outline'})
        });
    }, 
    filterCanton(value){
        this.customerAddress.province = value
        this.customerAddress.canton   = { code: "0", name: ''}
        this.tempCanton      = []
        this.customerAddress.district = { code: "0", name: ''}
        this.tempDistrict    = []
        console.log('this.cantons', this.cantons);
        this.tempCanton = this.cantons.filter((item) => {
            return value.code == item.pv01Code
        })
    },
    filterDistricts(value){
        this.customerAddress.canton   = value
        this.tempDistrict    = []
        this.customerAddress.district = { code: "0", name: ''}
        this.tempDistrict = this.districts.filter((item) => {              
            return value.code == item.ct01Code
        })
    },
    updateCustomerAddress(){
        this.$v.customerAddress.$touch()
        if (this.$v.customerAddress.$invalid) return
        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true
        ClientDataService.updateCutomerAddress(that.customerAddress)
        .then(response => {
            that.confirmStatus = false
            console.log('Actualizado',response)
            that.$vs.loading.close('#btnConfirm .con-vs-loading')
            that.$vs.notify({title:'Información!',text:'La dirección fue actualizado exitosamente!',color: 'success',icon:'check'})
            
            that.customer.pvcode  = that.customerAddress.province.code
            that.customer.pvname  = that.customerAddress.province.name
            that.customer.ctcode  = that.customerAddress.canton.code
            that.customer.ctname  = that.customerAddress.canton.name
            that.customer.dtcode  = that.customerAddress.district.code
            that.customer.dtname  = that.customerAddress.district.name
            that.customer.address = that.customerAddress.address
            
            that.customer.identification = that.customer.dni
            that.customer.firstName = that.customer.name
            that.customer.birthdate = that.customer.birthday
            that.customer.dlvCode = that.customer.delivery.code
            that.customer.dlvName = that.customer.delivery.name

            that.customer.bymail  = that.customer.byMail == true ? 1 : 0
            that.customer.bycall  = that.customer.byCall == true ? 1 : 0
            
            that.refreshCustomerStore()

        })
        .catch(e => {
            console.log(e)
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.confirmStatus = false
            that.$vs.notify({title:'Información!',text:'Error actualizando la dirección del cliente',color:'danger',icon:'error_outline'})                
        });
    },
    refreshCustomerStore(){
        
        let _userDataSession = {
            email: this.userInfoData.email, 
            name:  this.userInfoData.customer != null ? this.customer.name : this.user.name,
            lastName: this.userInfoData.customer != null ? this.customer.lastName : this.user.lastName,
            role:   this.userInfoData.role,
            boxkey: this.userInfoData.boxkey,
            profileUrl: this.userInfoData.customer != null ? this.customer.profileUrl : this.user.profileUrl,
            customer: this.userInfoData.customer != null ? this.customer : null
        }

        this.updatedUserInfo(_userDataSession)
    },
    loadCustomerFromStore(){
        this.customer.id        = this.userInfoData.customer.id
        this.customer.dni       = this.userInfoData.customer.identification
        this.customer.name      = this.userInfoData.customer.firstName
        this.customer.lastName  = this.userInfoData.customer.lastName
        this.customer.birthday  = new Date(this.userInfoData.customer.birthdate)
        this.customer.mobile    = this.userInfoData.customer.mobile
        this.customer.phone     = this.userInfoData.customer.phone
        this.customer.profession= this.userInfoData.customer.profession
        this.customer.hobbie    = this.userInfoData.customer.hobbie
        this.customer.email     = this.userInfoData.customer.email
        this.customer.byCall    = this.userInfoData.customer.bycall == 1 ? true : false
        this.customer.byMail    = this.userInfoData.customer.bymail == 1 ? true : false
        this.customer.whatsapp  = this.userInfoData.customer.whatsapp == 1 ? true : false
        this.customer.address   = this.userInfoData.customer.address
        this.customer.province = { code: this.userInfoData.customer.pvcode, name: this.userInfoData.customer.pvname}
        this.customer.canton   = { code: this.userInfoData.customer.ctcode, name: this.userInfoData.customer.ctname}
        this.customer.district = { code: this.userInfoData.customer.dtcode, name: this.userInfoData.customer.dtname}
        this.customer.delivery = { code: this.userInfoData.customer.dlvCode, name: this.userInfoData.customer.dlvName}
        this.customer.customerType = { code: this.userInfoData.customer.typecode, name: this.userInfoData.customer.typename}
        this.customerAddress.customer = this.customer.id
        this.customerAddress.userupd  = this.customer.email
    }
  }
}
</script>